'use strict'
const imageClientApi = require('./imageClientApi')
const constants = require('./helpers/imageServiceConstants')

const wixStatic = 'https://static.wixstatic.com/'

function getScaleToFitImageURL(relativeUrl, sourceWidth, sourceHeight, targetWidth, targetHeight, options) {
    const data = imageClientApi.getData(constants.fittingTypes.SCALE_TO_FIT, {
        id: relativeUrl,
        width: sourceWidth,
        height: sourceHeight
    }, {
        width: targetWidth,
        height: targetHeight,
        htmlTag: imageClientApi.htmlTag.IMG,
        alignment: imageClientApi.alignTypes.CENTER,
        pixelAspectRatio: window.devicePixelRatio
    }, options)

    return wixStatic + data.uri
}

function getScaleToFillImageURL(relativeUrl, sourceWidth, sourceHeight, targetWidth, targetHeight, options) {
    const data = imageClientApi.getData(constants.fittingTypes.SCALE_TO_FILL, {
        id: relativeUrl,
        width: sourceWidth,
        height: sourceHeight,
        focalPoint: {
            x: options && options.focalPoint && options.focalPoint.x, // eslint-disable-line lodash/prefer-get
            y: options && options.focalPoint && options.focalPoint.y // eslint-disable-line lodash/prefer-get
        }
    }, {
        width: targetWidth,
        height: targetHeight,
        htmlTag: imageClientApi.htmlTag.IMG,
        alignment: imageClientApi.alignTypes.CENTER,
        pixelAspectRatio: window.devicePixelRatio
    }, options)

    return wixStatic + data.uri
}

function getCropImageURL(relativeUrl, sourceWidth, sourceHeight, cropX, cropY, cropWidth, cropHeight, targetWidth, targetHeight, options) {
    const data = imageClientApi.getData(constants.fittingTypes.SCALE_TO_FILL, {
        id: relativeUrl,
        width: sourceWidth,
        height: sourceHeight,
        crop: {
            x: cropX,
            y: cropY,
            width: cropWidth,
            height: cropHeight
        }
    }, {
        width: targetWidth,
        height: targetHeight,
        htmlTag: imageClientApi.htmlTag.IMG,
        alignment: imageClientApi.alignTypes.CENTER,
        pixelAspectRatio: window.devicePixelRatio
    }, options)

    return wixStatic + data.uri
}

module.exports = {
    getScaleToFitImageURL,
    getScaleToFillImageURL,
    getCropImageURL
}


// WEBPACK FOOTER //
// ./src/main/imageClientSDK.js